import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  resetApi: [],

  contactCenterAttempt: ['callback', 'brand'],
  contactCenterSuccess: ['online'],
  contactCenterFailure: ['error'],
  contactCenterRetry: ['callback', 'brand'],
})
